export default __webpack_public_path__ + "static/media/close.a2fa552a.svg";